import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportNzIdWizardComponent } from './import-wizard/import-nz-id-wizard.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MaterialModule } from '../common/material/material.module';
import { ServiceModule } from '../service/service.module';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PipeModule } from '../common/pipe/pipe.module';
import { ImportReportDisplayComponent } from './importreport-display/import-report-display.component';
import { FormComponentsModule } from '../common/form/components/form-components.module';

@NgModule({
    declarations: [
        ImportNzIdWizardComponent,
    ], imports: [
        CommonModule,
        MaterialModule,
        ServiceModule,
        FormsModule,
        MatProgressSpinnerModule,
        PipeModule,
        ImportReportDisplayComponent,
        FormComponentsModule,
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class ImportNzIdWizardModule {
}
